import { render, staticRenderFns } from "./ProcessLegalBasis.vue?vue&type=template&id=4b8aacca&scoped=true&"
import script from "./ProcessLegalBasis.vue?vue&type=script&lang=js&"
export * from "./ProcessLegalBasis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8aacca",
  null
  
)

export default component.exports